import React from "react";
import { RouteProps } from "react-router-dom";

import { Helmet } from "react-helmet-async";
import ReturnSpecificCases from "../tools/RoutesTools";
import CpntPage from "../components/CpntPage";
import { IBreadCrumbs } from "../models/interfaces/IBreadCrumbs";

type PublicRouteProps = RouteProps & {
  component: React.ComponentType<any>;
  ReturnPath?: string;
  ReturnPathAlt?: string;
  ReturnTitle?: string;
  ReturnClass?: string;
  BreadCrumbs?: IBreadCrumbs[];
  indexSEO?: boolean;
}

const PublicRoute: React.FC<PublicRouteProps> = ({
  component: Component,
  ReturnPath,
  ReturnPathAlt,
  ReturnTitle,
  ReturnClass,
  BreadCrumbs,
  indexSEO,
  ...rest
}) => {
  return (
  <>
          {indexSEO === false && (
            <Helmet>
              <meta name="robots" content="noindex" />
            </Helmet>
          )}
          <CpntPage
            ReturnPath={ReturnSpecificCases({ ReturnPath, ReturnPathAlt, rest })}
            ReturnTitle={ReturnTitle}
            ReturnClass={ReturnClass}
            BreadCrumbs={BreadCrumbs}
          >
            <Component />
          </CpntPage>
        </>
  );
}

export default PublicRoute;